import { Badge, BadgeSize, BadgeVariant } from "shared/components";
import FailedIcon from "shared/icons/status-icons/fail-icon.svg?react";

export type SubscriptionBadgeProps = {
  status: "not_enrolled" | "enrolled" | "error";
};

export const SubscriptionBadge = ({ status }: SubscriptionBadgeProps) => {
  switch (status) {
    case "enrolled":
      return (
        <Badge
          variant={BadgeVariant.SUCCESS}
          size={BadgeSize.SM}
          className="flex items-center justify-center"
        >
          Active
        </Badge>
      );

    case "not_enrolled":
      return (
        <Badge
          variant={BadgeVariant.BASE}
          size={BadgeSize.SM}
          className="flex items-center justify-center"
        >
          Inactive
        </Badge>
      );

    case "error":
      return (
        <Badge
          variant={BadgeVariant.ERROR}
          size={BadgeSize.SM}
          className="flex items-center justify-center"
        >
          <FailedIcon className="h-3 w-3 stroke-danger-500" />
          Failed to subscribe
        </Badge>
      );

    default:
      <Badge
        variant={BadgeVariant.BASE}
        size={BadgeSize.SM}
        className="flex items-center justify-center"
      >
        {status}
      </Badge>;
  }
};
